import React from "react";
import { withRouter } from "react-router-dom";
import CompraTransaccionesCard from "./CompraTransaccionesCard";

class ComprasTransacciones extends React.Component {

    irCompra = (order) => {
        this.props.history.push('/compras?compra_id=' + order.com_id);
        this.props.history.go();
    }

    render() {
        const { compra } = this.props;

        return (
            <section className='splitBox'>
                <h2>
                    Transacción #{compra.transaction.reference_code}
                </h2>
                <div className="d-flex justify-content-center">
                    {compra.transaction.transaction_orders.map((order, index) =>
                        <CompraTransaccionesCard key={index} originalOrder={compra} order={order} index={index} irCompra={this.irCompra} />
                    )}
                </div>
            </section>
        );
    }
}

export default withRouter(ComprasTransacciones);
